const getChargeAmpsApiPath = (): string => {
    if (location.hostname === 'localhost' && process.env.API_SERVER) {
        return process.env.API_SERVER
    }
    return '/api'
}

export default getChargeAmpsApiPath
